import { readLocalDb, writeLocalDb } from '../../lib';

export const getRefreshToken = (): string  => readLocalDb('refreshToken');
export const setRefreshToken = (input = '') => writeLocalDb('refreshToken', input);

export const getAccessToken = (): string  => readLocalDb('accessToken');
export const setAccessToken = (input = '') => writeLocalDb('accessToken', input);
